import { threeStore } from '@modules/three/store/threeStore.ts';

const useThreeStore = () => {
  const cameraControls = threeStore((state) => state.cameraControls);
  const setCameraControls = threeStore((state) => state.setCameraControls);
  const rootState = threeStore((state) => state.rootState);
  const setRootState = threeStore((state) => state.setRootState);
  const isLoading = threeStore((state) => state.isLoading);
  const setIsLoading = threeStore((state) => state.setIsLoading);

  return {
    cameraControls,
    setCameraControls,
    rootState,
    setRootState,
    isLoading,
    setIsLoading,
  };
};

export default useThreeStore;
